import * as THREE from "three";

export function arrayToVector(value) {
  // Array to vector conversions
  if (Array.isArray(value)) {
    if (value.length === 2) {
      value = new THREE.Vector2(value[0], value[1]);
    }
    if (value.length === 3) {
      value = new THREE.Vector3(value[0], value[1], value[2]);
    }
  }
  return value;
}
